module.exports = __webpack_public_path__ + "static/media/gold-card-back.8738a85b.png";